import { render } from "./Overlay.vue?vue&type=template&id=2d717266"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"
script.render = render

export default script